<template>
    <div>
        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="16" >
                    <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
                        <el-form-item label="支付流水号">
                            <el-input v-model="formInline.thirdTradNo" placeholder="支付流水号"></el-input>
                        </el-form-item>
                        <el-form-item label="主订单号">
                            <el-input v-model="formInline.orderNo" placeholder="主订单号"></el-input>
                        </el-form-item>
                        <el-form-item label="下单日期">
                            <el-date-picker
                                    v-model="formInline.date"
                                    type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="选择下单日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="getUserSource">查询</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </div>

        <el-table :data="invite" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="activeInviteDetailEntity.orderMainNo" label="订单号" width="170"></el-table-column>
            <el-table-column prop="activeEntity.activeName" label="活动名称" width="170" ></el-table-column>
            <el-table-column prop="activeInviteDetailEntity.createTime" label="活动参与时间" ></el-table-column>
            <el-table-column prop="source.nickName" label="来源" width="150">
                <template slot-scope="scope">
                    <a :href="getUserDetailUrl(scope.row.activeInviteDetailEntity.customerId)" alt="点击查看邀请用户" target="_blank">{{scope.row.source.nickName==null?'无':scope.row.source.nickName==''?'未关注用户':scope.row.source.nickName}}</a>
                </template>
            </el-table-column>
            <el-table-column prop="activeInviteDetailEntity.status" label="状态" width="80" sortable>
                <template slot-scope="scope">
                    <span>{{scope.row.source.nickName==null?(scope.row.activeInviteDetailEntity.status == 1 ? '参与成功' : '未支付'):(scope.row.activeInviteDetailEntity.status == 1 ? '成功邀请' : '未支付')}}</span>
                </template>
            </el-table-column>

        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>

    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getUserSourceApi
    } from '../../api/api';
    export default {
        data() {
            return {
                formInline: {
                    thirdTradNo: "",
                    orderNo: "",
                    date:'',
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
                loading: true,
                invite:[]
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getUserSource();
        },
        methods: {
            getUserSource() {
                if(this.formInline.thirdTradNo==""&&this.formInline.orderNo==""){
                    this.$message({
                        showClose: true,
                        message: '请输入流水号或订单号查询',
                        type: 'success'
                    });
                    this.loading=false;
                    return;
                }
                this.loading = true;
                getUserSourceApi(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.invite = res.data.value;
//                        this.formInline.recordsTotal = res.data.value.list.total;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            returnHistory(){
                window.history.back()
            },
            handleEdit(collageConfig){
//                this.listCollageShow = false;
            },
            getUserDetailUrl(customerId){
                return '//erpnew.lechun.cc/mall_customer_edit.html?customerid='+customerId;
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getUserSource();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getUserSource();
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/fit/invite.vue